class BrowserStringBuilder {
  private readonly parts: unknown[] = [];
  private readonly newline = '\n';

  constructor(value?: unknown) {
    this.append(value);
  }

  append(value: unknown): this {
    if (value != null) {
      this.parts.push(value);
    }

    return this;
  }

  appendLine(value?: unknown): this {
    this.parts.push(this.newline);

    if (value != null) {
      this.parts.push(value);
    }

    return this;
  }

  appendFormat(format: string, ...values: unknown[]): this {
    const replacements =
      values.length === 1 &&
      typeof values[0] === 'object' &&
      values[0] !== null &&
      !(values[0] instanceof String)
        ? (values[0] as Record<string, unknown>)
        : values;

    this.parts.push(
      format.replace(/({?){([^}]+)}(}?)/g, (match, open, key, close) => {
        if (open === '{' && close === '}') {
          return match;
        }

        const value = Array.isArray(replacements)
          ? replacements[Number(key)]
          : replacements[key];

        return value == null ? '' : String(value);
      })
    );

    return this;
  }

  clear(): void {
    this.parts.length = 0;
  }

  toString(): string {
    return this.parts.join('');
  }
}

export const StringBuilder: any = BrowserStringBuilder;
